export interface UpdateUserMynumbercardRequest {
  id: string
  ppid: string
}

export function UpdateUserMynumbercardRequestToJSON(
  value: UpdateUserMynumbercardRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    ppid: value.ppid !== '' ? value.ppid : undefined
  }
}
